import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Button, Container, TextField, Typography } from '@material-ui/core';
import { ArrowBack, Send } from '@material-ui/icons';
import swal from 'sweetalert';
import Api from '../utils/api';

const ForgotPassword = () => {
  const api = new Api();

  const handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);

    try {
      await api.post('/users/forgot-password', { email: values.email });

      await swal({
        title: 'Email enviado!',
        text: 'Verifique sua caixa de entrada para redefinir sua senha.',
        icon: 'success',
        button: 'Ok'
      });

      actions.resetForm();
    } catch (error) {
      console.error('Erro ao solicitar recuperação:', error);
      const errorMessage =
        error.response?.data?.message || 'Erro ao enviar email. Por favor, tente novamente.';

      swal({
        title: 'Erro',
        text: errorMessage,
        icon: 'error'
      });
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Recuperar Senha | Sistema de Afiliados</title>
      </Helmet>
      <section
        style={{
          position: 'relative',
          minHeight: '100vh',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(180deg, rgba(255,255,255,.25), rgba(105, 80, 162, 0.5))',
            zIndex: 1
          }}
        />

        <div style={{ position: 'relative', zIndex: 2 }}>
          <Box
            sx={{
              backgroundColor: 'transparent',
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
              width: '100vw',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Container
              maxWidth="sm"
              sx={{ backgroundColor: 'rgba(255,255,255,0.95)', borderRadius: 2, p: 4, boxShadow: 5 }}
            >
              <Formik
                initialValues={{
                  email: ''
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string().email('Email inválido').required('Email é obrigatório')
                })}
                onSubmit={handleSubmit}
              >
                {({ errors, handleBlur, handleChange, handleSubmit: formikHandleSubmit, isSubmitting, touched, values }) => (
                  <form onSubmit={formikHandleSubmit}>
                    <Box
                      sx={{
                        mb: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <img
                        alt="Logo"
                        src="/static/logo.png"
                        style={{
                          width: 'auto',
                          height: 75,
                          resize: 'contain'
                        }}
                      />
                    </Box>

                    <Box sx={{ mb: 3 }}>
                      <Typography color="textPrimary" variant="h2">
                        Recuperar Senha
                      </Typography>
                      <Typography color="textSecondary" gutterBottom variant="body2">
                        Digite seu email para receber o link de recuperação
                      </Typography>
                    </Box>

                    <TextField
                      error={Boolean(touched.email && errors.email)}
                      fullWidth
                      helperText={touched.email && errors.email}
                      label="Email"
                      margin="normal"
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="email"
                      value={values.email}
                      variant="outlined"
                      inputProps={{
                        style: {
                          backgroundColor: 'white'
                        }
                      }}
                    />

                    <Box sx={{ py: 2 }}>
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        startIcon={<Send />}
                      >
                        {isSubmitting ? 'Enviando...' : 'Enviar link de recuperação'}
                      </Button>
                    </Box>

                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                      <Link to="/login" style={{ color: '#5048E5', textDecoration: 'none', fontWeight: 600 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <ArrowBack sx={{ mr: 1, fontSize: 18 }} />
                          Voltar para login
                        </Box>
                      </Link>
                    </Box>
                  </form>
                )}
              </Formik>
            </Container>
          </Box>
        </div>
      </section>
    </>
  );
};

export default ForgotPassword;
